// EmptyState.jsx
// Modern component for displaying no results state with call-to-action

import React from 'react';
import { styles } from './styles';
import { EmptyBoxIcon, PlusIcon } from '../../components/Icons';

const EmptyState = () => {
  const handleAddListing = () => {
    // Navigate to add listing page
    window.location.href = '/add-listing';
  };

  return (
    <div style={styles.emptyState} className="empty-state">
      <div style={styles.emptyIcon}>
        <EmptyBoxIcon size={40} color="#CE1126" />
      </div>
      
      <h3 style={styles.emptyTitle}>No items found</h3>
      <p style={styles.emptyText}>
        No listings match your current search criteria. Try adjusting your filters, 
        or be the first to add an item to the marketplace!
      </p>
      
      <button 
        style={styles.emptyAction}
        onClick={handleAddListing}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#a00f20';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 8px 24px rgba(206, 17, 38, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#CE1126';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}
      >
        <PlusIcon size={18} color="white" />
        Add First Item
      </button>
    </div>
  );
};

export default EmptyState;